<template>
    <div>
        <!-- Filters in white card -->
        <div class="mb-2 p-2">
            <div class="col-sm-12 search-form-title">
                <font-awesome-icon icon="search" />
                {{ $t('common.search') }}
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label class="small"><b>{{ $t('invoice_history.start_date') }}</b></label>
                    <input type="date" class="form-control form-control-sm" v-model="startDate" />
                </div>
                <div class="col-sm-6">
                    <label class="small"><b>{{ $t('invoice_history.end_date') }}</b></label>
                    <input type="date" class="form-control form-control-sm" v-model="endDate" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label class="small"><b>{{ $t('invoice_history.contract') }}</b></label>
                    <open-contract-filter
                        :from="startDate"
                        :to="endDate"
                        :show-company="false"
                        :show-title="false"
                        :showOnlyMyContractsOption="true"
                        @contractSelected="setContract"
                    />
                </div>
                <div class="col-sm-6">
                    <label class="small"><b>{{ $t('invoice_history.status') }}</b></label>
                    <select class="form-control form-control-sm" v-model="status">
                        <option value="">{{ $t('invoice_history.all') }}</option>
                        <option :value="1">{{ $t('daily_summary.invoice_state_not_invoiced') }}</option>
                        <option :value="2">{{ $t('daily_summary.ready_for_invoicing') }}</option>
                        <option :value="4">{{ $t('daily_summary.rejected') }}</option>
                    </select>
                </div>
            </div>
            <div class="col-sm-12 button-container">
                <button
                    class="btn btn-primary"
                    :disabled="loading"
                    @click.stop="fetchData"
                >
                    {{ $t('common.search') }}
                </button>
            </div>
        </div>

        <!-- No results -->
        <Transition name="fade">
            <div v-if="!loading && data.length < 1"  class="col-12 text-center" style="padding-top: 20vh; color: #bcbcbc; font-size: 2em; font-weight: 300">
                {{ $t('common.no_results') }}
            </div>
        </Transition>

        <!-- Summary cards (Contract count, Not invoiced, Ready for invoicing, Total Sum) -->
        <not-invoiced-summary :data="data"/>

        <!-- Results by contract -->
        <transition name="fade">
            <div v-if="data && data.length > 0" class="pt-2">
                <vue3-datatable
                    :rows="data"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    :sortable="false"
                    :height="data.length < 7 ? '100%' : '40vh'"
                    skin="bh-table-compact"
                    cell-class="routa-table-cell"
                >
                    <template #contract="data">
                        {{ data.value.contract.id}} - {{ data.value.contract.name }}
                    </template>
                    <template #not_invoiced="data">
                        {{ formatCurrency(data.value.not_invoiced) }}
                    </template>
                    <template #ready_for_invoicing="data">
                        {{ formatCurrency(data.value.ready_for_invoicing) }}
                    </template>
                    <template #returned="data">
                        {{ formatCurrency(data.value.returned) }}
                    </template>
                    <template #total="data">
                        {{ formatCurrency(data.value.not_invoiced + data.value.ready_for_invoicing) }}
                    </template>
                </vue3-datatable>
            </div>
        </transition>

        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import { restApi } from '../mixins/RestApiMixin'
import { timeUtils } from '../mixins/TimeUtils'
import Vue3Datatable from '@bhplugin/vue3-datatable'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import OpenContractFilter from "../contract/OpenContractFilter.vue";
import { priceHelper} from "../mixins/PricingMixin.js";
import {invoicingHelper} from "../mixins/InvoicingMixin.js";
import NotInvoicedSummary from "./NotInvoicdeSummary.vue";

export default {
    name: 'NotInvoiced',
    components: {
        NotInvoicedSummary,
        OpenContractFilter,
        FontAwesomeIcon,
        Vue3Datatable
    },
    mixins: [restApi, timeUtils, priceHelper, invoicingHelper],
    props: {
        user: { type: Object, default: null }
    },
    data() {
        return {
            fields: [
                { field: 'contract', title: this.$t('invoice_history.contract'), sort: false, headerClass: 'routa-table-header' },
                { field: 'not_invoiced', title: this.$t('daily_summary.invoice_state_not_invoiced'), sort: false, headerClass: 'routa-table-header' },
                { field: 'ready_for_invoicing', title: this.$t('daily_summary.ready_for_invoicing'), sort: false, headerClass: 'routa-table-header' },
                { field: 'returned', title: this.$t('daily_summary.rejected'), sort: false, headerClass: 'routa-table-header' },
                { field: 'total', title: this.$t('common.total'), sort: false, headerClass: 'routa-table-header' },
            ],
            data: [],
            loading: false,
            contract: null,
            startDate: '',
            endDate: '',
            status: null,
        }
    },
    mounted() {
        this.startDate = this.timestampToDateInput(this.getMonthStartAsDate().getTime())
        this.endDate = this.timestampToDateInput(new Date().getTime())
    },
    methods: {
        fetchData() {
            this.loading = true
            this.data = []
            this.restFetchParams(this.notInvoicdeUrl, {
                from: this.getDateAsString(new Date(this.startDate)),
                to: this.getDateAsString(new Date(this.endDate)),
                status: this.status,
                contract: this.contract
            }, this.handleResponse)
        },

        setContract(contract) {
            this.contract = contract ? contract.id : null
        },

        handleResponse(response) {
            this.loading = false
            if (response && response.data) {
                this.data = response.data
            }
        }

    }
}
</script>

<style scoped>
</style>
